import React, { useMemo, useCallback } from 'react';
import { fetchEventQuestions } from '../../data/fetch';
import Loader from './Loader';
import { useStoredDataChanged } from './useStoredDataChanged';
import { useEventQuestions } from '../../data/hooks/questions/useEventQuestions';
import { useScheduledAction, useForceUpdate } from '../../misc/hooks';
import { throttle } from 'lodash';
import moment from 'moment';

const clearCache = throttle(() => {
    fetchEventQuestions.cache.clear();
}, 1 * 60 * 60 * 1000);

const LoadQAQuestions = ({ eventId, skipSpinner, children }) => {
    const questions = useEventQuestions(eventId),
        forceUpdate = useForceUpdate(),
        nextUpdate = useMemo(
            () =>
                questions
                    .map((q) => q.attachment_expires)
                    .sort()
                    .pop(),
            [questions]
        );

    const reloadQuestions = useCallback(() => {
        clearCache();
        forceUpdate();
    }, []);

    useScheduledAction(nextUpdate, reloadQuestions);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={(state) => skipSpinner || state.events[eventId]?.questions.loaded} promises={[fetchEventQuestions(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadQAQuestions;
